<template>
  <div class="flex h-max items-center">
    <button
      class="mr-2 flex cursor-pointer items-center justify-center rounded-md p-1"
      @click="handleBusinessNoteVisibilityScope"
    >
      <tooltip>
        <template v-if="!isDealActivityPipModeActivated" #content>
          <p class="mb-1 font-medium">
            {{ $t("DEALS.DEAL_NOTES.INTERNAL_NOTE") }}
          </p>
          <p>{{ $t("DEALS.DEAL_NOTES.INTERNAL_NOTE_DESCRIPTION") }}</p>
        </template>
        <template #default>
          <icon-base
            height="24"
            width="24"
            viewBox="0 0 18 14"
            :icon="IconShowPassNoBg"
            :icon-color="visibilityScopeIconColor"
            class="mt-1 ml-1"
          />
        </template>
      </tooltip>
    </button>
  </div>
</template>
<script setup lang="ts">
import { computed } from "vue";

import { storeToRefs } from "pinia";

import { NOTE_VISIBILITY_SCOPE, UTIL_COLORS } from "@/helpers/constants";
import useNotesStore from "@/stores/notes";

import IconShowPassNoBg from "@/components/icons/IconShowPassNoBg.vue";

const { visibilityScope } = defineProps<{
  visibilityScope: number;
}>();

const { ALL, LENDFLOW } = NOTE_VISIBILITY_SCOPE;
const notesStore = useNotesStore();
const { isDealActivityPipModeActivated } = storeToRefs(notesStore);

const emit = defineEmits(["changeScope"]);

const visibilityScopeIconColor = computed(() =>
  visibilityScope === ALL ? UTIL_COLORS.DEFAULT : UTIL_COLORS.PRIMARY
);

const handleBusinessNoteVisibilityScope = () => {
  const emittedValue = visibilityScope === ALL ? LENDFLOW : ALL;
  emit("changeScope", emittedValue);
};
</script>
